var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({attrs:{"type":"text","placeholder":"Szukaj w Castorama ...","name":"q","value":"","ceid":"Wyszukiwarka - pole tekstowe","maxlength":"128","autocomplete":"off","tabindex":"0"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }